import { authStore } from 'store/mobx/auth.store';
import { setCookie } from './fun_cookie';

export function error(fun, text) {
  if (text.error_code === 1003) {
    setCookie('token', '');
    authStore.clear();
  }
}
